comments-notifications
  notifications-read-indicator(each="{id in opts.items}" tag-scope="notification_{id}")
  script(type="typescript").
    this.mixin('base');
  style(scoped).
    :scope {
      display: block;
      text-align: right;
    }
